import AutoShutdownDetails from "./AutoShutdownDetails.vue"
export default AutoShutdownDetails
